// src/hooks/useDebounce.ts
import { useEffect, useState } from "react";

/** Devuelve el valor después de que el usuario deja de escribir (para búsquedas). */
export function useDebounce<T>(value: T, delay = 400): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
